export const CHECKOUT = 'https://checkout.centerlinetactical.com/diffuse/cop-121345-1762520906435919-1777412720937273';
export const ATTRIBUTION_ENDPOINT = 'https://ct-diffuse-meta-capi.dmcauliff.workers.dev/attribution/capture';
export const INITIATE_CHECKOUT_ENDPOINT = 'https://ct-diffuse-meta-capi.dmcauliff.workers.dev/events/initiate-checkout';
export const PIXEL_ID = '323765382532921';
const allowed = ['fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','campaign_id','adset_id','ad_id','placement','site_source_name','site_source','ab_test','ab_variant','_fbc','_fbp'];
const analyticsAllowed = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','campaign_id','adset_id','ad_id','placement'];

export function isReviewMode() {
  return globalThis.document?.querySelector('meta[name="ct-review-mode"]')?.content === 'true';
}

export function routeContext(pathname = globalThis.location?.pathname || '/') {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return normalizedPath === '/challenger'
    ? { variant: 'challenger', lander: 'cf_everyday_conflict' }
    : { variant: 'control', lander: 'cf_control_clone' };
}

export function checkoutUrl(location, search = globalThis.location?.search || '', pathname = globalThis.location?.pathname || '/') {
  const destination = new URL(CHECKOUT);
  const incoming = new URLSearchParams(search);
  const context = routeContext(pathname);
  allowed.forEach((key) => { const value = incoming.get(key); if (value) destination.searchParams.set(key, value); });
  destination.searchParams.set('ct_lander', context.lander);
  destination.searchParams.set('ct_variant', context.variant);
  destination.searchParams.set('ct_cta_location', location);
  return destination.href;
}

const volatileStorage = new Map();

function readStorage(storageName, key) {
  const fallbackKey = `${storageName}:${key}`;
  try {
    const value = globalThis[storageName]?.getItem(key);
    if (value !== null && value !== undefined) return value;
  } catch { /* storage can be blocked by browser privacy settings */ }
  return volatileStorage.get(fallbackKey) || null;
}

function writeStorage(storageName, key, value) {
  const fallbackKey = `${storageName}:${key}`;
  volatileStorage.set(fallbackKey, value);
  try { globalThis[storageName]?.setItem(key, value); } catch { /* volatile fallback remains available */ }
}

function readCookie(name) {
  try {
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
  } catch { return ''; }
}

function initiateCheckoutPayload(eventId) {
  const params = new URLSearchParams(window.location.search);
  const context = routeContext();
  const sourceUrl = new URL(window.location.pathname, window.location.origin);
  const payload = {
    event_id: eventId,
    href: sourceUrl.href,
    content_name: 'DIFFUSE',
    content_category: 'Self Defense Course',
    content_type: 'product',
    currency: 'USD',
    value: 37,
    ct_variant: context.variant,
    ct_lander: context.lander,
  };
  allowed.forEach((key) => {
    const value = params.get(key);
    if (!value) return;
    payload[key] = value;
    sourceUrl.searchParams.set(key, value);
  });
  payload.fbp = readCookie('_fbp') || payload._fbp || '';
  payload.fbc = readCookie('_fbc') || payload._fbc || '';
  delete payload._fbp;
  delete payload._fbc;
  payload.href = sourceUrl.href;
  return payload;
}

function sendInitiateCheckout(eventId) {
  const body = JSON.stringify(initiateCheckoutPayload(eventId));
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(INITIATE_CHECKOUT_ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    fetch(INITIATE_CHECKOUT_ENDPOINT, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true, mode: 'cors', credentials: 'omit' }).catch(() => {});
  } catch { /* checkout navigation must remain independent */ }
}

function opaqueId(key) {
  let value = readStorage('localStorage', key);
  if (!value) { value = crypto.randomUUID(); writeStorage('localStorage', key, value); }
  return value;
}

function session() {
  const now = Date.now();
  let prior = null;
  try { prior = JSON.parse(readStorage('localStorage', 'ct_session') || 'null'); } catch { /* replace corrupt state */ }
  const current = prior && now - prior.last < 1800000 ? prior : { id: crypto.randomUUID(), started: now };
  current.last = now;
  writeStorage('localStorage', 'ct_session', JSON.stringify(current));
  return current;
}

const pageKey = crypto.randomUUID();
const once = new Set();
export function event(name, metadata = {}, oneTime = '') {
  if (isReviewMode()) return;
  const dedupe = oneTime && `${pageKey}:${oneTime}`;
  if (dedupe && once.has(dedupe)) return;
  if (dedupe) once.add(dedupe);
  const params = new URLSearchParams(window.location.search);
  const s = session();
  const payload = {
    schema_version: 1, event_name: name, visitor_id: opaqueId('ct_visitor'), session_id: s.id,
    path: window.location.pathname, variant: routeContext().variant, viewport_width: window.innerWidth,
    referrer_host: document.referrer ? new URL(document.referrer).hostname : '', metadata
  };
  analyticsAllowed.forEach((key) => { const value = params.get(key); if (value) payload[key] = value; });
  const body = JSON.stringify(payload);
  if (navigator.sendBeacon && navigator.sendBeacon('/api/events', new Blob([body], { type: 'application/json' }))) return;
  fetch('/api/events', { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => {});
}

export function captureAttribution(reason) {
  if (isReviewMode()) return;
  const params = new URLSearchParams(window.location.search);
  const context = routeContext();
  const sanitizedUrl = new URL(window.location.pathname, window.location.origin);
  const payload = { href: sanitizedUrl.href, reason, ct_variant: context.variant, ct_lander: context.lander };
  allowed.forEach((key) => {
    const value = params.get(key);
    if (!value) return;
    payload[key] = value;
    sanitizedUrl.searchParams.set(key, value);
  });
  payload.href = sanitizedUrl.href;
  const body = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(ATTRIBUTION_ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    fetch(ATTRIBUTION_ENDPOINT, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => {});
  } catch { /* checkout and render must remain independent */ }
}

export function initMeta() {
  if (isReviewMode()) return;
  if (window.fbq) return;
  const fbq = window.fbq = function (...args) {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  };
  window._fbq = fbq;
  fbq.push = fbq;
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  const script = document.createElement('script'); script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.append(script);
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
  fbq('track', 'ViewContent', {
    content_name: 'DIFFUSE', content_category: 'Self Defense Course', content_type: 'product', currency: 'USD', value: 37,
  });
}

export function initTracking() {
  if (isReviewMode()) return;
  initMeta(); captureAttribution('page_load');
  event('session_start', {}, 'session_start'); event('page_view');
  setTimeout(() => event('engaged_10s', {}, 'engaged_10s'), 10000);
  const observed = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) event('section_view', { section_id: entry.target.dataset.section }, `section:${entry.target.dataset.section}`);
  }), { threshold: 0.25 });
  document.querySelectorAll('[data-section]').forEach((el) => observed.observe(el));
  const thresholds = [25, 50, 75, 90, 100];
  const onScroll = () => {
    const available = document.documentElement.scrollHeight - window.innerHeight;
    const depth = available <= 0 ? 100 : Math.min(100, Math.round(window.scrollY / available * 100));
    thresholds.forEach((threshold) => { if (depth >= threshold) event('scroll_depth', { depth: threshold }, `scroll:${threshold}`); });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  try {
    const vital = (name, value) => event('web_vital', { vital_name: name, value: Math.round(value * 100) / 100 }, `vital:${name}`);
    new PerformanceObserver((list) => list.getEntries().forEach((e) => vital('LCP', e.startTime))).observe({ type: 'largest-contentful-paint', buffered: true });
    let cls = 0; new PerformanceObserver((list) => { list.getEntries().forEach((e) => { if (!e.hadRecentInput) cls += e.value; }); vital('CLS', cls); }).observe({ type: 'layout-shift', buffered: true });
    new PerformanceObserver((list) => list.getEntries().forEach((e) => vital('INP', e.duration))).observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch { /* unsupported browser */ }
}

export function handleCheckout(link, clickEvent) {
  clickEvent?.preventDefault();
  const location = link.dataset.cta;
  let eventId = readStorage('sessionStorage', 'ct_meta_ic');
  const shouldSend = !eventId || !eventId.startsWith('ic:');
  if (shouldSend) {
    eventId = `ic:${Date.now()}:${crypto.randomUUID()}`;
    writeStorage('sessionStorage', 'ct_meta_ic', eventId);
  }
  const destination = new URL(checkoutUrl(location));
  destination.searchParams.set('ct_ic_event_id', eventId);
  link.href = destination.href;
  event('cta_click', { cta_location: location });
  event('checkout_handoff', { cta_location: location });
  captureAttribution('cta_click');
  if (shouldSend) {
    sendInitiateCheckout(eventId);
    window.fbq?.('track', 'InitiateCheckout', {
      content_name: 'DIFFUSE', content_category: 'Self Defense Course', content_type: 'product', currency: 'USD', value: 37,
    }, { eventID: eventId });
  }
  globalThis.setTimeout(() => { window.location.href = link.href; }, 300);
}
